module.exports = __webpack_public_path__ + "img/bannerWhitelabelDefault.249c93c.png";